import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { _nextTrackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  LEARN_MORE_BANNER_CLICK: '3139',
  MANAGE_BANNER_CLICK: '3149',
} as const;

type BannerCSEventParams = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser | null;
  entryPoint?: string;
};

// https://dataportal.zillowgroup.net/event-registry/3139
export const emitLearnMoreBannerClickEvent = ({ currentProperty, user, entryPoint }: BannerCSEventParams) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '213',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.LEARN_MORE_BANNER_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'rental_protection_banner',
      trigger_source_nm: 'find_out_more',
    },
    semantic: {
      semantic_event_nm: 'start_rental_protection_opt_in_flow',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    zrm_rp_info: {
      funnel_starting_point_txt: entryPoint,
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3149
export const emitManageRentalProtectionBannerClickEvent = ({ currentProperty, user }: BannerCSEventParams) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MANAGE_BANNER_CLICK,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'rental_protection_banner',
      trigger_source_nm: 'manage_rental_protection',
    },
    semantic: {
      semantic_event_nm: 'manage_rental_protection_policy',
      topic_tag_txt: ['zrm_rental_protection'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
